import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedDocument } from '../../../models/share/share';
import { ExplainModuleEnum } from "../../../shared/services/module-manager.service";

@Component({
  selector: 'app-share-panel',
  templateUrl: './share-panel.component.html',
  styleUrls: ['./share-panel.component.scss']
})
export class SharePanelComponent {
  @Input({required: true}) document!: SharedDocument;
  @Input() withExportPanel: boolean = false;
  @Output() toggle = new EventEmitter<boolean>();
  protected readonly ExplainModuleEnum = ExplainModuleEnum;
}
